import React from 'react';
import { RouteConfig } from '../../config/routes.config';
import ProtectedLayout from '../layouts/ProtectedLayout';
import { useSidebarState } from '../../hooks/useSidebarState';

/**
 * Helper component to render route content with proper layout
 */
const RouteContent: React.FC<{ config: RouteConfig }> = ({ config }) => {
  // Single source of truth for sidebar state
  const { toggleSidebar, user, sidebarProps } = useSidebarState();
  
  const { 
    path, 
    component: Component, 
    layout = 'standard',
    fullscreenClass = '',
    protected: isProtected = false,
    showSidebar = true,
  } = config;

  // Extract the base path for sidebar highlighting
  const currentPath = '/' + path.split('/')[1];

  // For protected routes with standard or fullscreen layout
  if (isProtected) {
    return (
      <ProtectedLayout 
        currentPath={currentPath}
        fullscreenClass={fullscreenClass}
        showSidebar={showSidebar}
        sidebarProps={sidebarProps}
      >
        {layout === 'standard' ? (
          <main className="app-main">
            <Component 
              user={user}
              onToggleSidebar={toggleSidebar}
              onSignOut={sidebarProps.onSignOut}
              onClose={() => {}} // Navigation handled by component itself
            />
          </main>
        ) : (
          <Component 
            user={user}
            onToggleSidebar={toggleSidebar}
            onSignOut={sidebarProps.onSignOut}
            onClose={() => {}} // Navigation handled by component itself
          />
        )}
      </ProtectedLayout>
    );
  }

  // For non-protected routes
  return <Component user={user} />;
};

export default RouteContent;

